<div *ngIf="!loading">
  <app-ficha-lista-home *ngIf="newHome"></app-ficha-lista-home>
  <app-ficha *ngIf="!newHome"></app-ficha>
</div>
